"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const PeopleStore_1 = require("../../model/PeopleStore");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const FluShotsAdministered_1 = require("./FluShotsAdministered");
const hui_1 = require("@mit/hui");
const UploadModalTests_1 = __importDefault(require("../completedTests/UploadModalTests"));
const FluShotsComponent = ({ covidNav, roles }) => {
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShowUpload = () => {
        setShow(true);
    };
    const handleCloseUpload = () => {
        setShow(false);
    };
    (0, react_1.useEffect)(() => {
        if ((PeopleStore_1.peopleStore === null || PeopleStore_1.peopleStore === void 0 ? void 0 : PeopleStore_1.peopleStore.fluShotsList) === undefined && isLoading === false) {
            setLoading(true);
            let searchDate = new Date();
            let dateString = `${searchDate.getFullYear()}-${searchDate.getMonth() + 1 < 10 ? "0" + (searchDate.getMonth() + 1) : searchDate.getMonth() + 1}-${searchDate.getDate() < 10 ? "0" + searchDate.getDate() : searchDate.getDate()}`;
            setLoading(true);
            covidNav.currentDateString = dateString;
            MedicalApi_1.default.fetchFluShotResults(dateString).then((fluShotDetailResponse) => {
                if (fluShotDetailResponse.error) {
                    setLoading(false);
                    //todo: handle error
                }
                else if (fluShotDetailResponse.unauth) {
                    setUnAuth(true);
                }
                else {
                    if (fluShotDetailResponse.items) {
                        setLoading(false);
                        PeopleStore_1.peopleStore.setFluShotList(fluShotDetailResponse.items);
                    }
                }
            });
        }
    });
    const reloadDataCompleted = (date) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        covidNav.currentDateString = date;
        const fluShotDetailResponse = yield MedicalApi_1.default.fetchFluShotResults(date);
        if (fluShotDetailResponse.error) {
            setLoading(false);
            //todo: handle error
        }
        else if (fluShotDetailResponse.unauth) {
            setUnAuth(true);
        }
        else {
            if (fluShotDetailResponse.items) {
                setLoading(false);
                PeopleStore_1.peopleStore.setFluShotList(fluShotDetailResponse.items);
            }
        }
    });
    const getInitialCalendarValue = () => {
        let searchDate = new Date();
        let dateString = `${searchDate.getFullYear()}-${searchDate.getMonth() + 1 < 10 ? "0" + (searchDate.getMonth() + 1) : searchDate.getMonth() + 1}-${searchDate.getDate() < 10 ? "0" + searchDate.getDate() : searchDate.getDate()}`;
        return dateString;
    };
    if (unAuth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "calendar-picker" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-xl-4" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-xl-4" }, { children: (0, jsx_runtime_1.jsx)(hui_1.CalendarInput, { onChange: (e) => reloadDataCompleted(e), value: getInitialCalendarValue(), id: "flushotDateSelector" }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-xl-4" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "controls" }, { children: (roles === null || roles === void 0 ? void 0 : roles.roles.includes("medical")) && (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary, text: "Import Results", onClick: () => handleShowUpload() }) })) }))] })) })), (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ peopleStore: PeopleStore_1.peopleStore }, { children: (0, jsx_runtime_1.jsx)(FluShotsAdministered_1.FluShotsAdministered, { isLoading: isLoading }) })), (0, jsx_runtime_1.jsx)(UploadModalTests_1.default, { show: show, onClose: handleCloseUpload })] }));
};
const FluShots = (0, mobx_react_1.inject)("covidNav", "roles")((0, mobx_react_1.observer)(FluShotsComponent));
exports.default = FluShots;
